import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListEmspUserFirstNameCell } from './emsp-bo-rfid-badge-order-list-emsp-user-first-name.cell';
import { EmspBoRfidBadgeOrderListEmspUserFirstNameHeader } from './emsp-bo-rfid-badge-order-list-emsp-user-first-name.header';

export const EmspBoRfidBadgeOrderListEmspUserFirstNameColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['emspUser']['firstName']
> = {
  id: 'emspUserFirstName',
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListEmspUserFirstNameHeader,
  cell: EmspBoRfidBadgeOrderListEmspUserFirstNameCell,
};
